import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth0',
  templateUrl: './auth0.component.html',
  styleUrls: ['./auth0.component.css']
})
export class Auth0Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
